var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../box';
import { stackBaseStyle, responsiveStackSpaceStyle } from './styles';
const Root = styled(Box)(stackBaseStyle, responsiveStackSpaceStyle);
export const Stack = forwardRef((props, ref) => {
    const { as, space } = props, restProps = __rest(props, ["as", "space"]);
    return (React.createElement(Root, Object.assign({ "data-as": typeof as === 'string' ? as : undefined, "data-ui": "Stack" }, restProps, { "$space": space, forwardedAs: as, ref: ref })));
});
Stack.displayName = 'Stack';
//# sourceMappingURL=stack.js.map